import { render } from "./CcmpProTask.vue?vue&type=template&id=f7953fb2&scoped=true&bindings={\"id\":\"props\",\"lesson\":\"options\",\"objectives\":\"options\",\"ccmpProTitle\":\"options\",\"onObjectiveClick\":\"options\",\"formatTopicId\":\"options\",\"formatTaskId\":\"options\",\"formatRichText\":\"options\"}"
import script from "./CcmpProTask.vue?vue&type=script&lang=js"
export * from "./CcmpProTask.vue?vue&type=script&lang=js"

import "./CcmpProTask.vue?vue&type=style&index=0&id=f7953fb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f7953fb2"

export default script